<template>
  <div class="container">
    <div class="head">
      <img src="../assets/images/logo-cutout.png" alt="Logo cutout" />
      <h2>
        Xsensible <br />
        community
      </h2>
    </div>
    <p>Sign up for Xsensible community</p>
    <div class="form-container">
      <div class="steps hide-mobile">
        <div class="step">
          <img src="../assets/images/01.png" alt="" />
          <p>Your info</p>
        </div>
      </div>
      <div class="steps-mobile only-mobile">
        <progress-ring class="ring" :progress="0">
          <span>01.</span>
        </progress-ring>
        <p>Add your Xsensible</p>
      </div>
      <div class="form-row">
        <div class="form-row-one">
          <label for="firstName">Your name*</label>
          <input
            v-model="firstName"
            type="text"
            id="firstName"
            placeholder="First name"
            class="input focus"
          />
        </div>
        <input
          v-model="surname"
          type="text"
          placeholder="Surname"
          class="input focus"
        />
      </div>
      <div class="form-row">
        <div class="form-row-one">
          <label for="email">Your email*</label>
          <input
            v-model="email"
            type="email"
            id="email"
            placeholder="E-mailadres"
            class="input focus"
          />
        </div>
        <div class="form-row-one">
          <label>Purchased at*</label>
          <v-select
            :value="$store.state.campaignData.storeNumber"
            :components="{ OpenIndicator }"
            :options="$store.getters.stores"
            :clearable="false"
            :reduce="store => store.id"
            @input="setStoreNumber"
            @search="onSearch"
            placeholder="Type City or Name"
            class="select"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-row-one">
          <label>Gender</label>
          <div class="form-control-radio">
            <div>
              <input type="radio" value="M" v-model="gender" id="male" />
              <label for="male">Male</label>
            </div>
            <div>
              <input type="radio" value="F" v-model="gender" id="female" />
              <label for="female">Female</label>
            </div>
          </div>
        </div>
      </div>
      <div class="error" v-show="$store.state.errorMessage">
        {{ $store.state.errorMessage }}
      </div>
    </div>
    <div class="end">
      <img src="../assets/icons/round-information-button.svg" alt="Info" />
      <p>
        Please enter the city where you bought your shoes and choose the store.
        You can start typing the store name or the name of the city. In case you
        have bought your Xsensible shoes online, just selecting the store name
        is enough.
      </p>
    </div>
    <div class="end-btn-wrapper">
      <div></div>
      <div>
        <button
          class="btn btn-primary"
          style="float: right;"
          @click="next"
          :disabled="!$store.state.campaignData.storeNumber"
        >
          <Loader v-if="$store.state.isLoading" />
          {{ $store.state.isLoading ? '' : 'Next' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import Loader from '@/components/Loader'

const caret = Vue.component('SelectCaret', {
  render: function(createElement) {
    return createElement('img', {
      attrs: {
        src: require('../assets/icons/chevron-down.svg')
      }
    })
  }
})

export default {
  name: 'StepOne',
  components: { vSelect, Loader },
  data() {
    return {
      OpenIndicator: caret,
      debounce: null,
      firstName: this.$store.state.user.firstName,
      surname: this.$store.state.user.surname,
      email: this.$store.state.user.email,
      gender: this.$store.state.user.gender
    }
  },
  methods: {
    onSearch(search, loading) {
      if (search) {
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          loading(true)
          this.$store
            .dispatch('getStores', search)
            .then(() => loading(false))
            .catch(() => {
              loading(false)
            })
        }, 200)
      }
    },
    setStoreNumber(storeNumber) {
      this.$store.commit('setCampaignData', { storeNumber })
    },
    async next() {
      this.$store.commit('setLoading', true)
      try {
        await this.updateUser()
      } catch (e) {
        return this.$store.commit('setLoading', false)
      }
      this.$store.commit('setLoading', false)
      if (this.$store.state.campaignData.storeNumber) {
        this.$store.commit('setErrorMessage', null)
        await this.$router.push('step-2')
      }
    },
    async updateUser() {
      const { email, firstName, surname, gender } = this.$store.state.user
      if (
        this.email !== email ||
        this.firstName !== firstName ||
        this.surname !== surname ||
        this.gender !== gender
      ) {
        await this.$store.dispatch('updateUser', {
          firstName: this.firstName,
          surname: this.surname,
          email: this.email,
          gender: this.gender
        })
      }
    }
  },
  mounted() {
    const userData = localStorage.getItem('userData')
    if (!this.$store.getters.userExists && userData) {
      this.$store.commit('setUser', JSON.parse(userData))
    }
    this.firstName = this.$store.state.user.firstName
    this.surname = this.$store.state.user.surname
    this.email = this.$store.state.user.email
    this.gender = this.$store.state.user.gender
  }
}
</script>

<style lang="scss">
@import '../assets/styles/v-select-override';
@import '~@/assets/styles/forms.scss';

.head {
  display: flex;

  h2 {
    font-size: 38px;
    margin: 0;
    padding-left: 17px;
    font-weight: normal;
  }
}

.end {
  display: flex;
  background-color: #f5f5f5;
  margin-top: 70px;
  width: 100%;

  img {
    padding-left: 25px;
  }

  p {
    padding: 30px;
    margin: 0;
    line-height: 1.5;
  }
}

.end-btn-wrapper {
  margin-top: 53px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 767px) {
    .btn {
      padding-left: 0;
      padding-right: 0;
      width: 100%;
    }
  }
}
</style>
